import { render, staticRenderFns } from "./chatBanned.vue?vue&type=template&id=39b456a2&"
import script from "./chatBanned.vue?vue&type=script&lang=js&"
export * from "./chatBanned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b456a2')) {
      api.createRecord('39b456a2', component.options)
    } else {
      api.reload('39b456a2', component.options)
    }
    module.hot.accept("./chatBanned.vue?vue&type=template&id=39b456a2&", function () {
      api.rerender('39b456a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/chatBanned.vue"
export default component.exports